import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft, faChartColumn } from "@fortawesome/free-solid-svg-icons";

import { MobileContext } from 'context';
import { useGameDetails, useKeyPress } from 'utils/Hooks';
import { ReactComponent as Chevron } from 'assets/symbols/ChevronRight.svg';
import './styles.scss';

function PredictionHeadline(props) {
  const isMobile = useContext(MobileContext);
  const navigate = useNavigate();

  const gameDetails = useGameDetails();

  const [currentPosition, SetCurrentPosition] = useState(null);

  const addresses = ['/bsc/bnb', '/bsc/btc'];
  const predictionRoot = '/prediction';
  const location = useLocation();

  useKeyPress(['h'], GoToHistory);
  useKeyPress(['c'], ToggleChart);

  function DetermineCurrentPosition() {
    const currentLocation = location.pathname;
    for (let i = 0; i < addresses.length; i++) {
      const wantedLocation = predictionRoot + addresses[i];
      if (wantedLocation == currentLocation)
        return i;
    }
    return -1;
  }

  useEffect(() => {
    SetCurrentPosition(DetermineCurrentPosition())
  }, []);

  function PreviousGame() {
    let wantedPosition = null;
    if (currentPosition - 1 < 0)
      wantedPosition = addresses.length - 1;
    else
      wantedPosition = currentPosition - 1;
    navigate(predictionRoot + addresses[wantedPosition]);
  }

  function NextGame() {
    let wantedPosition = null;
    if (currentPosition + 1 >= addresses.length)
      wantedPosition = 0;
    else
      wantedPosition = currentPosition + 1;
    navigate(predictionRoot + addresses[wantedPosition]);
  }

  function GoToHistory() {
    const historyPath = location.pathname.replace('prediction', 'history');
    navigate(historyPath);
  }
  function GetHistoryPath() {
    return location.pathname.replace('prediction', 'history');
  }

  function ToggleChart() {
    let destination = null;
    if (location.hash == '#chart')
      destination = '#cards'
    else
      destination = '#chart'
    window.location.href = destination;
  }


  return (
    <div id='cards' className={'Headline' + (isMobile ? ' Mobile' : '')} >
      <Link to={GetHistoryPath()}>
        <div className='NavigationButton'>
          <FontAwesomeIcon icon={faClockRotateLeft} className='w-6' />
          {isMobile ? '' : 'History'}
        </div>
      </Link>
      <div className='GameCarousel' >
        <div className='Previous' onClick={PreviousGame}>
          <Chevron className='Chevron' />
        </div>
        <div className='CentralElement'>
          <div className='Currency' >
            <img src={gameDetails.logo} />
          </div>
          <div id='Divide' />
          <div className='Chain' >
            <img src={gameDetails.wantedChain.logo} />
          </div>
        </div>
        <div className='Next' onClick={NextGame}>
          <Chevron className='Chevron' />
        </div>
      </div>
      {/* <button className='NavigationButton' onClick={() => window.location.href = '#chart'} >*/}
      <button className='text-white bg-violet-500 rounded-full w-32 h-12' onClick={() => window.location.href = '#chart'} >
        <FontAwesomeIcon icon={faChartColumn} className='w-6' />
        {isMobile ? '' : 'Chart'}
      </button>
    </div>
  );
}

export default PredictionHeadline;
